var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main tw-flex tw-items-center tw-flex-col tw-justify-center tw-h-fit"},[_c('div',{staticClass:"container tw-relative tw-bg-white md:tw-rounded-lg tw-p-3 lg:tw-px-24 tw-pb-20"},[(_vm.pending)?_c('loading-spinner',{attrs:{"is-overlay":true,"size":"50"}}):_vm._e(),_vm._v(" "),(!_vm.pending)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }